export const iconFontAwesomeSecurityPersonRifle = (
	<i className="fa-solid fa-person-rifle"></i>
);
